<template>
	<div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm" v-on:keyup.enter="pagina = 1;verifyAvaliacoes();" placeholder="Título, avaliador">
						<label for="search">Pesquisar</label>
					</div>		
				</div>
				<div class="row">
					<div class="input-field col s12">
						<label style="font-size: 16px;"><b>Filtros</b></label>
					</div>	
				</div>
				<div class="row">
					 <div class="input-field col s12 m6 l6 xl6">
						<select name="centro" v-model="centroSelected" @change="verifyUnidades();" class="browser-default select_sec">
							<option selected disabled value="-1">Escolha o centro</option>
							<option value="0">Todos os centros</option>
							<option v-for="centro in this.cens" v-bind:value="centro.id" >{{centro.nome}}</option>
						</select>
					 </div>
					 <div class="input-field col s12 m6 l6 xl6">
						<select name="unidade" v-model="uniSelected" class="browser-default select_sec">
							<option selected disabled value="-1">Escolha a unidade</option>
							<option value="0">Todas as unidades</option>
							<option v-for="unidade in this.unis" v-bind:value="unidade.id">{{unidade.nome}}</option>
						</select>
					 </div>
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s3">
				<button :disabled="uniSelected < 0" class="btn teal" @click="pagina = 1;verifyAvaliacoes();"><i class="material-icons left">search</i>Pesquisar</button>
			</div>	
		</div>
		
		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<col width="5%">
					<col width="40%">
					<col width="40%">
					<col width="5%">
					<col width="10%">
					<thead>
						<tr>
							<th>#
								<a class="left" href="#" @click="toggleOrder($event, 'id')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'inscricao.acao.titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
								</a>
							</th>
							<th>
								Avaliador
								<a class="left" href="#" @click="toggleOrder($event, 'user.name')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyAvaliador }" >sort</i>
								</a>
							</th>
							<th>
								Nota
							</th>
							<th>
								Status
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(avaliacao, index) in filteredAvaliacoes" :key="index">
							<td>{{index + 1 + tamPagina * (pagina - 1)}}</td>
							<td>
								<a :href="'/avaliacoes-aval/' + avaliacao.id">
									{{avaliacao.inscricao.acao.titulo}}
								</a>
							</td>
							<td>
								<a v-if='avaliacao.user' :href="'/usuario/' + avaliacao.user.id">
									{{avaliacao.user.name}}
								</a>
								<span v-else style="color:red;">
									<b>Avaliador não escolhido</b>
								</span>
							</td>
							<td>
								{{avaliacao.pontuacao_total}}	
							</td>
							<td> 
								<span v-if='!avaliacao.impedido && !avaliacao.invalido'>
									<label v-if='avaliacao.status_de_conclusao === "Finalizado" && avaliacao.user_id' class="waves-light btn left green">Finalizado</label>
									<label v-if='avaliacao.status_de_conclusao === "Em Andamento" && avaliacao.user_id' class="waves-light btn left amber darken-3">Andamento</label>
									<label v-if='avaliacao.status_de_conclusao === "Distribuído" && avaliacao.user_id' class="waves-light btn left blue lighten-2">Distribuído</label>
									<label v-if='!avaliacao.user_id' class="waves-light btn left red">Vazio</label>
								</span>
								<span v-else>
									<label v-if='avaliacao.invalido' class="waves-light btn left red">Inválido</label>
									<label v-else class="waves-light btn left red">Impedido</label>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn" @click="anterior()" :disabled='pagina <= 1'><i class="material-icons left">arrow_back_ios</i>Anterior</button>
			</div>
			<div class="input-field col s6 m6 l3 xl3">
				<button type="reset" class="btn" @click="proximo()" :disabled='pagina >= total'><i class="material-icons right">arrow_forward_ios</i>Próximo</button>
			</div>
		</div>
		
	</div>
	
</template>

<script>
	import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
		name: "VueAvaliacoesTodasList",
		props: [
			'centros'
		],
		components: {
            Loading
        },
		data () {
			return {
				listaAvaliacoes: [],
				sortDirection: 'asc',
				cens: JSON.parse(this.centros),
				unis: [],
				centroSelected: '-1',
				uniSelected: '-1',
				filterTerm: '',
				sortProperty: 'id',
				sortPropertyId: true,
				sortPropertyProjeto: false,
				sortPropertyAvaliador: false,
				pagina:1, 	
				total:0,
			    tamPagina: 0
				
			}
		},
		computed: {
			
			
			filteredAvaliacoes: function () {
				var self = this
				return _.orderBy(self.listaAvaliacoes, this.sortProperty, this.sortDirection)
			},
		},
		methods: {
			
			toggleOrder(ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field) {
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'id':
					  this.sortPropertyId = value
					  break;
					case 'titulo':
					  this.sortPropertyProjeto = value
					  break;
					case 'user.name':
					  this.sortPropertyAvaliador = value
					  break;  
					default:
				}
			},
			verifyUnidades: function () {
				this.uniSelected = '-1';

				if (this.centroSelected && this.centroSelected !== '0') 
					this.$http.get('/api/centros/' + this.centroSelected + '/unidade').then((req) => {this.unis = req.body})
				else
					this.unis = []
			},
			verifyAvaliacoes: function () {
				if (this.filterTerm.length < 3 && this.filterTerm.length > 0)
					showMsg('Para usar o filtro tem que ter pelo menos 3 caracteres', 0);
				else if (this.uniSelected >= 0) {
					var estilo = document.getElementById('spinner').style;
					
					estilo.display = null;
					this.$http.get('/api/avaliacoes-todas/' + this.centroSelected + '/' + this.uniSelected + (this.filterTerm.length >= 3? '/' + this.filterTerm : '') + '?page' + '=' + this.pagina).then((req) => {
						this.listaAvaliacoes = req.body.data; 
						this.total = req.body.last_page; 
						this.tamPagina = req.body.per_page; 
						estilo.display = 'none';
					})
				}
			},
			proximo: function () {
				this.pagina++;
				this.verifyAvaliacoes();
			},
			anterior: function () {
				this.pagina--;
				this.verifyAvaliacoes();
			}
		},		
	}
</script>